import {
  clickEventType, confirmationDialog,
  parse12hTime,
} from './helpers';

$(document).on(clickEventType, '.activity', (event) => {
  const id = $(event.target).parent().data('id');
  $.ajax({
    url: `/actual_plant_activities/${id}/edit.js`,
    type: 'GET',
  });
});

$(document).on('click', '.delete_plant_delivery', (event) => {
  event.preventDefault();
  const deliveryId = $(event.target).data('delivery-id');
  const approveCallback = function () {
    $.ajax({
      url: `/plant_deliveries/${deliveryId}`,
      type: 'DELETE',
    });
  };
  const denyCallback = function () { };
  confirmationDialog('This will delete this delivery forever. Are you sure?',
    approveCallback, denyCallback, 'Delete delivery');
});

$(document).on('click', '.date-picker-input', (event) => {
  const input = $(event.target);
  $('#change_date_form #datepicker')
    .datepicker({ dateFormat: 'yy-mm-dd' })
    .datepicker('option', 'onSelect', function (dateText) {
      input.val(dateText);
      $(this).parent().dialog('close');
    }).datepicker('setDate', input.val());

  $('#change_date_form').dialog({
    modal: true,
    title: 'Date',
    zIndex: 10000,
    width: 'auto',
    resizable: false,
    autoOpen: true,
    close() {
      $(this).dialog('destroy');
    },
  });
});
